<script lang="ts">
	import { track } from '$lib/services/tracking/googleAnalytics';
	import { trackLogoClick } from '$lib/services/tracking/googleAnalytics/tracking';
	import * as m from '$paraglide/messages';
	import Header from './Header.svelte';

	interface Props {
		onBackHome?: () => void;
	}

	const { onBackHome }: Props = $props();

	function handleClickBackHome() {
		track({
			action: 'back_to_homepage',
			payload: {
				action: 'click',
			},
		});

		onBackHome?.();
	}
</script>

<Header
	hasRoleBanner
	rightButton={{ text: m.action__back_home() }}
	onRightButtonClick={handleClickBackHome}
	onLogoClick={trackLogoClick}
/>
